<section class="treatment-option" [ngClass]="{selected:isSelected$|async}">
  <span class="treatment-option-column" *ngFor="let field of fields"
    [ngClass]="field?.cssClasses">
    <gen-textual-content
    [item]="data"
    [fieldConfig]="field"
    ></gen-textual-content>
  </span>
  <span class="treatment-option-column action-option info-option"
        *ngIf="infoFormId">
    <i class="fa fa-info-circle"
       (click)="infoClicked()"
    ></i>
  </span>
  <span class="treatment-option-column action-option toggle-switch-column"
        *ngIf="isSelectable">
    <gen-toggle-switch
      (statusUpdate)="selectClicked($event)"
      [disabled]="!(selectionAllowed$|async)"
      [active]="isSelected$|async"></gen-toggle-switch>
  </span>
</section>
